<div class="card-body">
    <div id="apex-radialbar-semi-circular-gauge"></div>
</div>